import { isEqual, isMatch } from 'lodash';
import qs from 'qs';

function isLocationMatch(currentLocation, toLocation, exact = false) {
  const toDecodedSearch = new URLSearchParams(toLocation.search).toString();
  const toQueryParameters = qs.parse(toDecodedSearch);
  const currentDecodedSearch = new URLSearchParams(
    currentLocation.search
  ).toString();
  const currentQueryParameters = qs.parse(currentDecodedSearch);
  const queryStringMatcher = exact ? isEqual : isMatch;
  const matching = isEqual(toLocation.pathname, currentLocation.pathname) && queryStringMatcher(currentQueryParameters, toQueryParameters);
  return matching;
}

export { isLocationMatch };
//# sourceMappingURL=utils.esm.js.map
